"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCampaignStringDateToDate = transformCampaignStringDateToDate;
function transformCampaignStringDateToDate(date) {
    // parameter as 20181106
    const year = parseInt(date.substr(0, 4));
    const month = parseInt(date.substr(4, 2));
    const day = parseInt(date.substr(6, 2));
    return new Date(year, month - 1, day, 0, 0, 0, 0);
}
//# sourceMappingURL=transformCampaignStringDateToDate.js.map